import store from '@/store';

export default function hasFeature(name) {
  const currentClient = store.getters['app/currentClient'];
  return currentClient && currentClient.features.indexOf(name) !== -1;
}
